<template>
    <div>
        <wb-nav></wb-nav>
        <wb-banner></wb-banner>
        <wb-feature></wb-feature>
        <wb-scene></wb-scene>
        <wb-footer></wb-footer>
    </div>
</template>

<script>
import header from '@/components/header'
import banner from '@/components/HomeBanner'
import feature from '@/components/HomeFeature'
import scene from '@/components/Homescene'
import footer from '@/components/footer'

    export default {
        name: 'Home',
        components: { // 定义组件
            'wb-nav': header,
            'wb-banner': banner,
            'wb-feature': feature,
            'wb-scene': scene,
            'wb-footer': footer
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/Home.vue